import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const CLUB_LAT = 53.696921;
const CLUB_LON = -0.417267;
const OSM_EMBED_BBOX = "-0.425,53.692,-0.410,53.702";

export function FindUs() {
  const mapEmbedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(OSM_EMBED_BBOX)}&layer=mapnik&marker=${CLUB_LAT}%2C${CLUB_LON}`;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Find us</h1>
        <p className="text-gray-600 mt-1">
          North Lincolnshire and Humberside Sailing Club
        </p>
      </div>

      <div className="prose prose-gray max-w-none">
        <p className="text-gray-700">
          Visitors to the Sailing Club are always welcome. However, there is no
          guarantee anyone will be at the club outside of scheduled Training
          Sessions or Events. Vehicular access to the club is only for members
          or by pre-arrangement — we recommend{" "}
          <Link to="/contact_us" className="text-primary-600 hover:text-primary-700 font-medium">
            contacting us
          </Link>{" "}
          to arrange a visit and avoid disappointment.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <div className="flex items-start gap-3 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
          <MapPin className="w-6 h-6 shrink-0 text-primary-600 mt-0.5" />
          <address className="text-gray-700 not-italic leading-relaxed">
            North Lincolnshire and Humberside Sailing Club
            <br />
            Barrow Mere
            <br />
            Barton-upon-Humber
            <br />
            DN18 5RB
            <br />
            <span className="text-gray-600 text-sm mt-2 block">
              Grid reference: TA 0459623439
              <br />
              Lat/Long: 53.696921°N, 0.417267°W
            </span>
          </address>
        </div>
        <div className="space-y-2">
          <div className="rounded-lg overflow-hidden border border-gray-200 bg-gray-100">
            <iframe
              title="Club location on OpenStreetMap"
              src={mapEmbedUrl}
              width="100%"
              height="350"
              className="border-0 block min-h-[280px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
